import { render, staticRenderFns } from "./WhyUsReason.vue?vue&type=template&id=6b393e12&scoped=true&"
import script from "./WhyUsReason.vue?vue&type=script&lang=js&"
export * from "./WhyUsReason.vue?vue&type=script&lang=js&"
import style0 from "./WhyUsReason.vue?vue&type=style&index=0&id=6b393e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b393e12",
  null
  
)

export default component.exports